import axios from 'axios'
import {
  Message
} from 'element-ui'
import storage from '@utils/storage/storage'
import Cookies from 'js-cookie'
import qs from 'qs'
import { clientVersion } from '../env'

// url配置
let env = {}
if (process.env.NODE_ENV === 'development') {
  env = {
    MAINTAIN_URL: 'https://test.school365.net.cn/system', // 维护地址
    ADMIN_URL: 'http://localhost:8089/admin/',
    // API_ROOT: 'https://connected.school365.org.cn/api',
    API_ROOT: 'https://test.school365.net.cn/api', // 接口地址
    BASE_URL: 'http://localhost:8071/admissions-pc-admin',
    PARENT_URL: 'http://localhost:8085/admissions',
    CURRICULUM_URL: 'http://localhost:3002/curriculum',
    WECHAT_URL: 'https://oauth.school365.org.cn/index.html', // 微信地址
    INTERATION_URL: 'http://localhost:8080/interaction', // 家校互动地址
    LIVE_URL: 'http://localhost:8070/live', // 直播
    LIVE_H5_URL: 'http://localhost:8085/live-h5', // 直播h5
    DOMAIN: 'localhost'
  }
} else if (process.env.NODE_ENV === 'testing' || process.env.NODE_ENV === 'release') {
  let url = location.origin.split('.')[0]
  env = {
    MAINTAIN_URL: `${url}.school365.net.cn/system`, // 维护地址
    ADMIN_URL: `${url}.school365.net.cn/admin`,
    API_ROOT: `${url}.school365.net.cn/api`, // 接口地址
    BASE_URL: `${url}.school365.net.cn/admissions-pc-admin`, // 招生地址
    PARENT_URL: `${url}.school365.net.cn/admissions`, // 招生家长端
    CURRICULUM_URL: `${url}.school365.net.cn/curriculum`, // 备课地址
    WECHAT_URL: 'https://oauth.school365.org.cn/index.html', // 微信地址
    INTERATION_URL: `${url}.school365.net.cn/interaction`, // 家校互动地址
    LIVE_URL: `${url}.school365.net.cn/live`, // 直播
    LIVE_H5_URL: `${url}.school365.net.cn/live-h5`, // 直播h5
    DOMAIN: location.host
  }
} else if (process.env.NODE_ENV === 'ncpa') {
  // ncpa 环境地址
  env = {
    MAINTAIN_URL: 'https://ncpaulc.school365.org.cn/system', // 维护地址
    ADMIN_URL: `https://ncpaulc.iss-ulink.org/admin`,
    API_ROOT: `https://ncpaulc.api.iss-ulink.org`, // 接口地址
    BASE_URL: `https://ncpaulc.iss-ulink.org/admissions`, // 招生地址
    CURRICULUM_URL: `https://ncpaulc.iss-ulink.org/curriculum`, // 备课地址
    WECHAT_URL: 'https://oauth.school365.org.cn/index.html', // 微信地址
    INTERATION_URL: `https://ncpaulc.iss-ulink.org/interaction`, // 家校互动地址
    DOMAIN: location.host
  }
} else if (process.env.NODE_ENV === 'ncic') {
  // ncic 环境地址
  env = {
    MAINTAIN_URL: 'https://ncic.school365.org.cn/system', // 维护地址
    ADMIN_URL: `https://ncic.iss-ulink.org/admin`,
    API_ROOT: `https://ncic.iss-ulink.org/api`, // 接口地址
    BASE_URL: `https://ncic.iss-ulink.org/admissions`, // 招生地址
    CURRICULUM_URL: `https://ncic.iss-ulink.org/curriculum`, // 备课地址
    WECHAT_URL: 'https://oauth.school365.org.cn/index.html', // 微信地址
    INTERATION_URL: `https://ncic.iss-ulink.org/interaction`, // 家校互动地址
    DOMAIN: location.host
  }
} else {
  let url = location.origin.split('.')[0]
  env = {
    MAINTAIN_URL: `${url}.school365.org.cn/system`, // 维护地址
    ADMIN_URL: `${url}.school365.org.cn/admin`,
    API_ROOT: `${url}.school365.org.cn/api`, // 接口地址
    BASE_URL: `${url}.school365.org.cn/admissions-pc-admin`, // 招生地址
    PARENT_URL: `${url}.school365.org.cn/admissions`, // 招生家长端
    CURRICULUM_URL: `${url}.school365.org.cn/curriculum`, // 备课地址
    WECHAT_URL: 'https://oauth.school365.org.cn/index.html', // 微信地址
    INTERATION_URL: `${url}.school365.org.cn/interaction`, // 家校互动地址
    LIVE_URL: `${url}.school365.org.cn/live`, // 直播
    LIVE_H5_URL: `${url}.school365.org.cn/live-h5`, // 直播h5
    DOMAIN: location.host
  }
}

// axios 配置
axios.defaults.timeout = 60000

const checkLogin = () => {
  storage.clearAll()
  Cookies.remove('userToken', { domain: env.DOMAIN })
  console.log('checkLogin')
  window.location.href = window.location.origin
}

axios.interceptors.request.use(config => {
  let Authorization = Cookies.get('Authorization', { domain: env.DOMAIN }) || ''
  if (Authorization) config.headers['Authorization'] = Authorization
  config.headers['moduleId'] = 0
  // if (Cookies.get('lang') !== null && Cookies.get('lang') !== 'null' && Cookies.get('lang') !== '' && Cookies.get('lang') !== undefined) {
  //   config.headers['local'] = Cookies.get('lang')
  // } else {
  //   config.headers['local'] = (navigator.language || navigator.userLanguage).substr(0, 2) === 'zh' ? 'zh_CN' : 'en_US'
  // }
  let lang = Cookies.get('lang') ? Cookies.get('lang') : (navigator.language || navigator.userLanguage).substr(0, 2)
  lang = lang === 'zh' ? 'zh_CN' : 'en_US'
  config.headers['local'] = lang
  config.headers['client_version'] = clientVersion
  return config
}, (err) => {
  Message.error('参数错误')
  return Promise.reject(err)
})
// 返回状态判断
axios.interceptors.response.use((response) => {
  let result = parseInt(response.data.result || 0)
  if (result === 0) {
    return response.data.result ? response.data : response
  } else if (result === 50008 || result === 50012 || result === 50014) { // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
    checkLogin()
  } else {
    Message({
      message: response.data.msg || response.msg,
      type: 'error'
    })
    return response.data || ''
  }
}, (error) => {
  let code = parseInt(error.response.status) || 0
  console.log(error.response)
  switch (code) {
    case 400:
    case 401:
      if (code === 400) {
        if (error.response.config.url.indexOf('/api/auth-service/thirdParty/token') !== -1) {
          let lang = Cookies.get('lang') ? Cookies.get('lang') : (navigator.language || navigator.userLanguage).substr(0, 2)
          lang = lang === 'zh' ? 'zh_CN' : 'en_US'
          Message({
            message: lang === 'zh_CN' ? '登录超时，请重新登录' : 'Login timeout, please log in again',
            type: 'error'
          })
          setTimeout(() => {
            window.location.href = location.origin + '/login'
          }, 3000)
        } else {
          Message({
            message: error.response.data.msg || 'Error',
            type: 'error'
          })
        }
      } else {
        Message({
          message: error.response.data.msg || 'Error',
          type: 'error'
        })
      }
      Cookies.remove('Authorization', { domain: env.DOMAIN })
      Cookies.remove('clientApp', { domain: env.DOMAIN })
      Cookies.remove('outTime', { domain: env.DOMAIN })
      Cookies.remove('tokenInfo', { domain: env.DOMAIN })
      break
    case 402:
    case 403:
      checkLogin()
      break
    default:
      Message({
        message: error.response.data.msg || 'Error',
        type: 'error'
      })
      return Promise.resolve(error)
  }
  return Promise.reject(error)
})

const ajax = (method, url, data, responseType) => {
  url = env.API_ROOT + url
  if (responseType === 'from') {
    data = qs.stringify(data)
    return new Promise((resolve, reject) => {
      axios.post(url, data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
        .catch(error => {
          reject(error)
        })
    })
  } else if (responseType === 'fdownload') {
    console.log('blob')
    return new Promise((resolve, reject) => {
      axios.get(url, {
        responseType: 'blob',
        data
      })
        .then(response => {
          console.log('123')
          resolve(response)
        })
        .catch(error => {
          console.log('error')
          reject(error)
        })
    })
  } else if (responseType === 'fupload') {
    return new Promise((resolve, reject) => {
      axios.post(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      })
        .then(response => {
          console.log('error')
          resolve(response)
        })
        .catch(error => {
          console.log('123')
          reject(error)
        })
    })
  } else if (responseType === 'deleteUpload') {
    console.log('deleteUpload')
    data = method === 'delete' ? {
      params: data
    } : data
    return new Promise((resolve, reject) => {
      axios[method](url, data, responseType)
        .then(response => {
          resolve(response)
        }, error => {
          reject(error)
        })
        .catch(error => {
          reject(error)
        })
    }).catch(error => {
      console.log(error)
    })
  } else {
    data = method === 'get' ? {
      params: data
    } : data
    return new Promise((resolve, reject) => {
      axios[method](url, data, responseType)
        .then(response => {
          resolve(response)
        }, error => {
          reject(error)
        })
        .catch(error => {
          reject(error)
        })
    }).catch(error => {
      console.log('error3')
      console.log(error)
    })
  }
}
const commonGet = (url, data) => {
  return ajax('get', url, data) // 其它的操作将对应的delete换成（put、post、get、delete）即可
}
const commonPost = (url, data) => {
  return ajax('post', url, data)
}
const commonFromPost = (url, data) => {
  return ajax('post', url, data, 'from')
}
const commonPut = (url, data) => {
  return ajax('put', url, data)
}
const commonDelete = (url, data) => {
  return ajax('delete', url, data)
}
const deleteUpload = (url, data) => {
  return ajax('delete', url, data, 'deleteUpload')
}
const fupload = (url, data) => {
  return ajax('post', url, data, 'fupload')
}
const fdownload = (url, data) => {
  return ajax('get', url, data, 'fdownload')
}

var request = {
  get: commonGet,
  post: commonPost,
  put: commonPut,
  delete: commonDelete,
  fromPost: commonFromPost,
  fupload: fupload,
  fdownload: fdownload,
  deleteUpload: deleteUpload
}

export default {
  request,
  env
}



// WEBPACK FOOTER //
// ./src/utils/ajax/http.js